/**
 * POS készpénz-fizetés loyalty-aware matek (bug-screen #3).
 *
 * A POS-on a loyalty-pont beváltás csökkenti a kasszába ténylegesen fizetendőt.
 * A `handleComplete` submit MÁR `total - loyaltyPointsToRedeem`-et számol — ez a
 * helper ehhez igazítja a Complete-gomb gate-jét + a visszajáró-kijelzést, hogy a
 * két fél ne térjen el (különben loyalty-beváltáskor a gomb tévesen tiltva marad,
 * a visszajáró pedig a loyalty-összeggel hibás).
 */

import { ApiError } from '@/api/client';

/** A loyalty-beváltás után ténylegesen fizetendő (kasszába) összeg. */
export function payableAfterLoyalty(total: number, loyaltyRedeem: number): number {
  return Math.max(0, total - loyaltyRedeem);
}

/** Visszajáró készpénz a loyalty-levonás utáni fizetendőhöz képest. */
export function changeDue(cashReceived: number, total: number, loyaltyRedeem: number): number {
  return Math.max(0, cashReceived - payableAfterLoyalty(total, loyaltyRedeem));
}

/** Elég-e a beérkezett készpénz a loyalty utáni fizetendőre. */
export function isCashSufficient(
  cashReceived: number,
  total: number,
  loyaltyRedeem: number
): boolean {
  return cashReceived >= payableAfterLoyalty(total, loyaltyRedeem);
}

/**
 * Loyalty-pont beváltási hiba → i18n toast-kulcs.
 *
 * A BE strukturált `error.code`-jára branch-el (#603 contract: `LOYALTY_*`),
 * NEM message-substring-re — i18n-biztos, robusztus. Ismeretlen vagy hiányzó code
 * (régi BE message-only / hálózati hiba) → generikus `redeemFailed` fallback,
 * tehát a #603-merge ELŐTT is biztonságos (graceful degradation).
 */
export function loyaltyErrorToastKey(error: unknown): string {
  const code = error instanceof ApiError ? error.code : undefined;
  switch (code) {
    case 'LOYALTY_CONCURRENT':
      return 'sales.pos.loyalty.concurrentRetry';
    case 'LOYALTY_INSUFFICIENT':
      return 'sales.pos.loyalty.insufficientPoints';
    default:
      return 'sales.pos.loyalty.redeemFailed';
  }
}
